import type { EnsoPhase } from './types';

/**
 * The ENSO year and the chain's arithmetic (M24): one copy, for the game
 * (`systems/climate.ts`, the readout) and for the index's build
 * (`scripts/data/oni.ts`), where each had been written two or three times
 * (review M25). Pure: no table is read here.
 */

/** The ENSO year's first month, July (a definition: an event grows through the northern summer, peaks around December and fades by spring). */
export const JULY = 7;

export const PHASES: readonly EnsoPhase[] = ['nino', 'neutral', 'nina'];

/** The ENSO year a month is in: the year its July is in. */
export function ensoYearOfMonth(year: number, month: number): number {
  return month >= JULY ? year : year - 1;
}

/** An ENSO year as the readout and the log write it: "2025-26". */
export function ensoYearLabel(year: number): string {
  return `${year}-${String((year + 1) % 100).padStart(2, '0')}`;
}

/** Steps taken from even shares to the long-run ones (a definition: the shares stop changing in the sixth decimal long before). */
const STEPS = 500;

/** A chain's long-run shares, solved from its rows rather than typed (Sable Reserve's way). */
export function stationaryShares(rows: Readonly<Record<EnsoPhase, Readonly<Record<EnsoPhase, number>>>>): Record<EnsoPhase, number> {
  let p: Record<EnsoPhase, number> = { nino: 1 / 3, neutral: 1 / 3, nina: 1 / 3 };
  for (let k = 0; k < STEPS; k++) {
    const next: Record<EnsoPhase, number> = { nino: 0, neutral: 0, nina: 0 };
    for (const from of PHASES) for (const to of PHASES) next[to] += p[from] * rows[from][to];
    p = next;
  }
  return p;
}
